// form setup
export const apDiameter = 
'Adjust the medial AP diameter of the IT level. <br/> \
Enter values based on the measurement value. However, this is for 1st setting,finalize it once adjustment of the all setting is done.'
export const ischiumCircumference =
'Adjust the circumference of the IT/Top level. <br/> \
Enter values based on the measurement value. However, this is for 1st setting, finalize it once adjustment of the all setting is done.' 
export const compression = 
'Compression rate of top shape. You inputted mesaured AP diameter and cirfumference. \
But when you use softinsert, for example, you need to adjust the circumference. But this depends on an interface.'
export const filletAdductorLongus = 
'Adjust the size of the fillet (semi-circular shape) on the anterior-medial corner. \
Basically, there is no need to change from the default value.'
export const point1X = 
'Move the Point left or right/ lateral or medial. <br/> \
＋: move to the right (lateral) <br/> \
ー: move to the left (medial) <br/> \
The position of point 1 should be halfway between 0 and 2, slightly more toward the center of the socket of IT level than the straight line connecting the two. \
If it goes too much inward, it will cause excessive pressure at the scarpa triangle area'
export const point1Z =
'Move the Point up or down/ posterior or anterior. <br/> \
＋: move to the down (anterior) <br/> \
ー: move to the up (posterior) <br/> \
The position of point 1 should be halfway between 0 and 2, slightly more toward the center of the socket of IT level than the straight line connecting the two. \
If it goes too much inward, it will cause excessive pressure at the scarpa triangle area'
export const rectusFemorisOverhang =
'Move the Point up or down/ posterior or anterior to decide the amount with the channel of the rectus femoris muscle. <br/> \
＋: move to the down (anterior) <br/> \
ー: move to the up (posterior) <br/> \
Guideline: Enter the following values according to the measurements of the stump IT level (Top) circumference. \
Adjust that value if it seems out of shape, etc. \
650mm or more   : 24 <br/> \
600mm - 649mm : 22 <br/> \
550mm - 599mm : 20 <br/> \
500mm - 549mm : 18 <br/> \
450mm - 499mm : 16 <br/> \
400mm - 449mm : 14 <br/> \
399mm or less     : 12'
export const point3X = 
'Move the Point left or right/ lateral or medial. <br/> \
＋: move to the right (lateral) <br/> \
ー: move to the left (medial)'
export const point3Z = 
'Move the Point up or down/ posterior or anterior. <br/> \
＋: move to the down (anterior) <br/> \
ー: move to the up (posterior) '
export const point4X = 
'Move the Point left or right/ lateral or medial. <br/> \
＋: move to the right (lateral) <br/> \
ー: move to the left (medial)'
export const point4Z = 
'Move the Point up or down/ posterior or anterior. <br/> \
＋: move to the down (anterior) <br/> \
ー: move to the up (posterior) '
export const point5X = 
'Move the Point left or right/ lateral or medial. <br/> \
＋: move to the right (lateral) <br/> \
ー: move to the left (medial) <br/> \
★About the outer/lateral arch (point 2-6) <br/> \
Adjust the position of points 3 and 5 to form one smooth line, like a semicircle shape.'
export const point5Z = 
'Move the Point up or down/ posterior or anterior. <br/> \
＋: move to the down (anterior) <br/> \
ー: move to the up (posterior) <br/> \
★About the outer/lateral arch (point 2-6) <br/> \
Adjust the position of points 3 and 5 to form one smooth line, like a semicircle shape.'
export const filletSideWall = 
'Adjust the Fillet of the curve connecting the back/posterior wall to the outer/lateral wall. <br/> \
Move the Point up or down/ posterior or anterior. <br/> \
＋: move to the down (anterior) <br/> \
ー: move to the up (posterior) <br/> \
Guideline: Enter the following values according to the measurements of the stump IT level (Top) circumference.Adjust that value if it seems out of shape, etc. <br/> \
600mm - 649mm : 80 <br/> \
500mm - 599mm : 70 <br/> \
400mm - 499mm : 60 <br/> \
399mm or less     : 50'
export const posteriorWallAngle =
'Adjust angle of back/posterior wall. Basically, there is no need to change from the default value.'
export const filletIschialTuberosity =
'Adjust the size of the fillet (semi-circular shape) on the Posterior-medial corner. Basically, there is no need to change from the default value.'

// Compression
export const initialAbductionAngle =
'Enter if the patient has abduction contracture based on the assessment sheet. <br/> \
However, it should be set as follows, not put actual measurement value. <br/> \
Measurement value <br/> \
0 - 5 degree → 0 degree <br/> \
6 - 10 degree → 5 degree <br/> \
11 - 15 degree → 10 degree <br/> \
16 - 20 degree → 15 degree <br/> \
*20 degrees or more : We can not accept <br/> \
*e.x. <br/> \
Measurement value : 3 degree → Actual value for modeling : 0 degree <br/> \
Measurement value : 12 degree → Actual value for modeling : 10 degree'
export const initialFlexionAngle =
'Enter if the patient has flexion contracture based on the assessment sheet. <br/> \
However, it should be set as follows, not put actual measurement value. <br/> \
0 - 10 degree → 5 degree <br/> \
11 - 20 degree → 10 degree <br/> \
*20 degrees or more : We can not accept <br/> \
*This setting is for Plug-in type , when making suction type , we need to use different setting.'
export const bottomExtensionCurveRadius =
'Adjust the circumferential diameter of the bottom surface of the socket. No need to change in principle.'
export const bottomExtensionAk =
'Adjust the socket bottom extension. In principle, no need to change from the default value of 20 mm.'
export const compressionIndividual = 
'Compression rate of each curve.'
export const ratioXY = 
'Adjust ratio between AP diameter and ML. Adjust the value while checking between stump shape and socket and its connection to the above and below outline'
export const circumferenceIndividual = 
'Adjust the circumference of each curve. Enter values based on the measurement value.'
export const tweenFactor =
'Select a value between 0 and 1. Adjust the value while checking between stump shape and socket and its connection to the above and below outline. <br/> \
As the value approaches 0, it becomes a circle, and as it approaches 1, it becomes a base shape. <br/> \
Recommendation: 0.7 - 0.8 '

// Lower trim

// Upper surface
export const trim2P0X = 
'Design the outside/lateral wall figure in the FRONT view. Basically, there is no need to change from the default value.'
export const trim2P0Y = trim2P0X
export const trim2P1X = trim2P0X
export const trim2P1Y = trim2P0X
export const trim2P2X = trim2P0X
export const trim2P2Y = trim2P0X
export const trim2P3Y = 
'Design the rear portion of the outside/lateral wall figure in the FRONT view. Basically, there is no need to change from the default value.'
export const trim2P3CenterVecAmplify = trim2P3Y
export const trim2P4Y = trim2P3Y
export const trim2P4CenterVecAmplify = trim2P3Y
export const trim2P5Y = trim2P3Y
export const trim2P5CenterVecAmplify = trim2P3Y
export const trim2P6Z =
'Design the outside/lateral portion of the front/anterior wall figure (Rectus femoris area). <br/> \
Basically, there is no need to change from the default value if stump length is standard one (and long one). <br/> \
For the short stump case, the outside/lateral portion of the front/anterior wall should be higher than the default by 10-15 mm <br/> \
For the long stump case, that height can be reduced from the default setting, but for the time being, we recommend doing test fitting with the standard setting to confirm the results. <br/> \
*The length of the tumps in this modeling is defined as follows <br/> \
- Short stump : (15cm)~20cm <br/> \
- Standard : 20cm~25cm <br/> \
- Long stump : 25cm~.'
export const trim2P6Y = trim2P6Z
export const trim2P7Z = trim2P6Z
export const trim2P7Y = trim2P6Z
export const trim2P8Z = 
'Design the inside/medial portion of the front/anterior wall figure. <br/> \
Basically, there is no need to change from the default value if stump length is standard one (and long one). <br/> \
For the short stump case, the outside/lateral portion of the front/anterior wall should be higher than the default by 10-15 mm. <br/> \
For the long stump case, that height can be reduced from the default setting, but for the time being, we recommend doing test fitting with the standard setting to confirm the results.'
export const trim2P8Y = trim2P8Z
export const trim2P9Z = trim2P8Z
export const trim2P9Y = trim2P8Z
export const trim2P10Z =
'Design the back/posterior wall figure.Basically, there is no need to change from the default value.'
export const trim2P10Y = trim2P10Z
export const trim2P11Z = trim2P10Z
export const trim2P11Y = trim2P10Z
export const trim2P12Z = trim2P10Z
export const trim2P12Y = trim2P10Z
export const trim2P13Z = trim2P10Z
export const trim2P13Y = trim2P10Z
export const trim2TrimSiX = 
'Basically, there is no need to change from the default value.If necessary, \
move each point of trim line for front area to forward/anterior or backward/posterior or/and right/lateral or left/medial <br/> \
AP <br/> \
+: move to the forward (anterior), -: move to the backward (posterior) <br/> \
ML <br/> \
+: move to the right (lateral), -: move to the left (medial)'
export const trim2TrimSiZ = trim2TrimSiX
export const trim2TrimSiBottomZ = trim2TrimSiX
export const trim2TrimSiP0X = trim2TrimSiX
export const trim2TrimSiP0Z = trim2TrimSiX
export const trim2TrimSiP1X = trim2TrimSiX
export const trim2TrimSiP1Z = trim2TrimSiX
export const trim2TrimSiP2X = trim2TrimSiX
export const trim2TrimSiP2Z = trim2TrimSiX
export const trim2TrimMlP0Z = 
'Determine the trim line point in front of the side wall , which is connected to the front/anterior wall. <br/> \
Set the pink line so that it passes through the intersection of the start of the outer/lateral wall line (red) , \
that is trimmed by “TRIM SI” and the flare line on the front/anterior wall (green). <br/> \
AP <br/> \
+: move to the forward (anterior), -: move to the backward (posterior) <br/> \
SI <br/> \
+: move to the up (proximal), -: move to the down (distal)'
export const trim2TrimMlP0Y = trim2TrimMlP0Z
export const trim2TrimMlP1Z = 
'Determine the curve apex of the trim line on the outer/lateral wall. <br/> \
The height at TRIM SI basically does not need to be changed. Normally, the trim line is set to cut approximately 60 mm above the IT level. <br/> \
Each point is moved in the AP direction and set to form one clean elliptical curve. <br/> \
AP <br/> \
+: move to the forward (anterior), -: move to the backward (posterior) <br/> \
SI <br/> \
+: move to the up (proximal), -: move to the down (distal)'
export const trim2TrimMlP1Y = trim2TrimMlP1Z
export const trim2TrimMlP2Z = trim2TrimMlP1Z
export const trim2TrimMlP2Y = trim2TrimMlP1Z
export const trim2TrimMlP3Z = 
'Determine the trim line point in back of the side wall , which is connected to the back/posterior wall. <br/> \
Set the pink line so that it passes through the intersection of the start of the outer/lateral wall line (red) ,\
 that is trimmed by “TRIM SI” and the flare line on the back/posterior wall (green). \n \
AP <br/> \
+: move to the forward (anterior), -: move to the backward (posterior) <br/> \
SI <br/> \
+: move to the up (proximal), -: move to the down (distal)'
export const trim2TrimMlP3Y = trim2TrimMlP3Z
// Assemble
export const assembleAkSocketMl =
'The position of the socket can be moved parallel to the knee joint.Basically, there is no need to change from the neutral position. <br/> \
Socket ML: <br/> \
+: Socket is moved to outward/lateral <br/> \
-: Socket is moved to inward/medial <br/> \
Socket AP: <br/> \
Basically, there is no need to change from the neutral position ,if use like below knee joint.'
export const assembleAkSocketAp = assembleAkSocketMl
export const assembleAkFdFlextionExtention =
'Changing the socket flexion or extension angle in the OUTSIDE view based on the check sheet after test fitting. <br/> \
+: increase socket flexion angle <br/> \
-: increase socket extension angle'
export const assembleAkFdAdductionAbduction = 
'Changing the socket adduction or abduction angle in the FRONT view based on the check sheet after test fitting. <br/> \
+: increase socket abduction angle <br/> \
-: increase socket adduction angle'
export const assembleAkFdSocketRotation = 
'Changing the socket inner/internal or outer/external rotation angle against the knee joint in the TOP view based on the check sheet after test fitting. <br/> \
+: Socket rotates outward/to external against knee joint <br/> \
-: Socket rotates inward/to internal against knee joint'
export const assembleAkFdSocketMl =
'Shifting the socket to inward/medial or outward/lateral against knee joint in the FRONT view based on the check sheet after test fitting. <br/> \
+: Socket is shifted to outward/lateral against knee joint <br/> \
-: Socket is shifted to inward/medial against knee joint'
export const assembleAkFdSocketAp =
'Shifting the socket to forward/anterior or backward/posterior against the knee joint in the OUTSIDE or INSIDE view based on the check sheet after test fitting. <br/> \
+: Socket is shifted to forward/anterior against knee joint <br/> \
-: Socket is shifted to backward/posterior against knee joint'
export const assembleAkFdSocketSi =
'Shifting the socket to up/proximal or down/distal in the OUTSIDE or INSIDE view based on the check sheet after test fitting. <br/> \
+: Socket is shifted to up/proximal <br/> \
-: Socket is shifted to down/distal'
// Output
export const socketThickness = 
'Change the thickness of the socket. Basically, there is no need to change from the default value.'
export const splitAdjust =
'Change the reference curve which is the last curve to be split and to be connected the bottom curve.'
export const radiusCheckHole =
'Change the diameter of the hole for checking the distal end of the stump.Basically, there is no need to change from the default value.'
export const intervalCheckHole = 
'Changed interval of check holes in the middle of the outer/lateral wall.Basically, there is no need to change from the default value.'
export const engraving = 
"Engraving the patient's number. If it is -1, engraving is not performed"